import useGetBanks, { type UseGetBanksReturn } from 'hooks/Bank/useGetBanks';
import type { Bank } from 'types/banks.types';

import _groupBy from 'lodash/groupBy';

export type BanksListReturn = {
  banksGrouped: Record<string, Bank[]>;
  mostCommonBanks: [string, Bank[]][];
  allOtherBanks: [string, Bank[]][];
  banksListQuery: UseGetBanksReturn;
};

const useBanksList = (): BanksListReturn => {
  const banksListQuery = useGetBanks();

  const banks = banksListQuery.data || [];

  const banksGrouped = _groupBy(banks, 'groupDisplayName');

  const mostCommonBanks = Object.entries(banksGrouped).filter(([, banks]) =>
    banks.find((bank) => bank.popular),
  );

  const allOtherBanks = Object.entries(banksGrouped).filter(([, banks]) =>
    banks.every((bank) => !bank.popular),
  );

  return {
    banksGrouped,
    mostCommonBanks,
    allOtherBanks,
    banksListQuery,
  };
};

export default useBanksList;
